// removed by extract-text-webpack-plugin
module.exports = {"logo":"src-components-modules-DevHeader-DevLogo-style----general-module---logo---V4Zu0","line":"src-components-modules-DevHeader-DevLogo-style----general-module---line---179Za display-inlineBlock verticalAlign-middle bg-white","developers":"src-components-modules-DevHeader-DevLogo-style----general-module---developers---2Lb1H fontSize-m fontWeight-5 c-white"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/DevHeader/DevLogo/style/general.module.css
// module id = 1447
// module chunks = 168707334958949